import React from 'react'
import ItemWrap from '../ItemWrap/index'
import { Button } from 'antd-mobile'
import './index.scss'
import ServiceAvatar from '@feedback/assets/images/official.png'
import UserAvatar from '@feedback/assets/images/image_user.png'
import { getTextByKey, getTimeFormat } from '@feedback/utils/util'
interface Props {
  itemData: any
  isLast: boolean
  openShowModal: any
  isComplete: boolean
  openImageModal: any
}
//工单回复的单个Item
const TicketItem: React.FC<Props> = ({ itemData, isLast, openShowModal, isComplete, openImageModal }) => {
  return (
    <ItemWrap timestamp={getTimeFormat(itemData.created_at)}>
      <div className='c-concat-item'>
        <div className={`concat-item ${itemData.push_user_type === 1 ? 'concat-user' : 'concat-service'}`}>
          <div className='avatar'>
            <img src={itemData.push_user_type === 1 ? UserAvatar : ServiceAvatar} alt='avatar' />
          </div>
          <div className='concat-content'>
            {itemData.reply_content ? (
              <div className='content-item content-text'>
                <div>{itemData.reply_content}</div>
                {Array.isArray(itemData.image_list) &&
                  itemData.image_list.map((item: string, index: number) => (
                    <div className='content-item content-image' key={index}>
                      <img src={item} onClick={() => openImageModal(item)} />
                    </div>
                  ))}
                {isLast && itemData.push_user_type === 2 && !isComplete && (
                  <div className='reply-group'>
                    <Button className='btn btn-resolved' onClick={openShowModal}>
                      {getTextByKey('solved')}
                    </Button>
                  </div>
                )}
              </div>
            ) : (
              <>
                {Array.isArray(itemData.image_list) &&
                  itemData.image_list.map((item: string, index: number) => (
                    <div className='content-item content-image' key={index}>
                      <img src={item} onClick={() => openImageModal(item)} />
                    </div>
                  ))}
              </>
            )}
          </div>
        </div>
      </div>
    </ItemWrap>
  )
}

export default TicketItem
